import { Divider, Table } from "antd";
import { getPercentage, msToTime, sum } from "../../utils/Utils";
export default function PageViews(props) {

    const { page_views = [] } = props;
  
    const total = sum(page_views, "views");

    const columns = [
        {
            title: <small>Route</small>, dataIndex: 'route', key: 'route', render: (e) => {
                return ("/" + e);
            }
        },
        {
            title: <small>Views</small>, dataIndex: 'views', key: 'views', render: (e) => {
                return (<div style={{ textAlign: "right" }}>{e}</div>)
            }
        },
        {
            title: <small>Unique</small>, dataIndex: 'unique_views', key: 'unique_views', render: (e) => {
                return (<div style={{ textAlign: "right" }}>{e}</div>)
            }
        },
        // {
        //     title: <small>Average Time</small>, dataIndex: 'average_ms', key: 'average_ms', render: (e) => {
        //         if (isNaN(e)) {
        //             return "";
        //         }
        //         return <>{msToTime(e * 1000)}</>
        //     }
        // },
        {
            title: <small>% of total views</small>, dataIndex: 'total_views', key: 'total_views', render: (e, f) => {
                const per = getPercentage(total, f.views).toFixed(2);
                const per_label = isNaN(per) ? "-" : per + "%";
                return <>{per_label}</>
            }
        },
    ]

    return (
        <>
            <strong className="c" style={{ "fontSize": "13px" }}>Page views</strong>
            <div style={{ "fontSize": "14px" }}><small>Breakdown of page views by popularity</small></div>
            <Divider dashed style={{ "margin": "10px 0px" }} />
            <Table bordered size="small" dataSource={page_views.sort((a, b) => b.views - a.views)} columns={columns} />
        </>
    )
}